import {
  RiBarChartBoxLine,
  RiCaravanLine,
  RiFunctionLine,
  RiProfileLine,
  RiShakeHandsLine,
  RiTeamLine,
  RiTodoFill,
  RiTodoLine
} from '@remixicon/react'
import {
  IconBoxAlignBottomLeft,
  IconBriefcase,
  IconBuilding,
  IconCar,
  IconCarCrane,
  IconCoinBitcoin,
  IconUser,
  IconUsersGroup
} from '@tabler/icons-react'
import { Perm_PriceBase_View, Perm_RequestOrder_View } from '../../app/hooks/premissionScreen'
import { createCollapseGroup, createItem } from '../../help'
import ROUTES from '../../routers/helpersRouter/constantRouter'
import { MenuItem } from '../../types'

const icons = {
  RiFunctionLine,
  RiProfileLine,
  RiBarChartBoxLine,
  RiTodoFill,
  RiTodoLine,
  RiTeamLine,
  RiShakeHandsLine,
  RiCaravanLine,
  IconUsersGroup,
  IconCoinBitcoin,
  IconBuilding,
  IconUser,
  IconBriefcase,
  IconCarCrane,
  IconBoxAlignBottomLeft,
  IconCar
}

export const generalMenuItem: MenuItem[] = [
  createCollapseGroup({
    id: 'list-general',
    title: 'Quản lý chung',
    icon: icons.RiTodoLine,
    iconActive: icons.RiTodoFill,
    premissions: Perm_RequestOrder_View,
    children: [
      createItem({
        id: 'general-request',
        title: 'Yêu cầu',
        url: `/${ROUTES.STATISTICAL}/${ROUTES.STATISTICAL_CHILD.REQUEST}`,
        premissions: Perm_RequestOrder_View
      }),
      createItem({
        id: 'general-base-price',
        title: 'Giá cơ sở',
        url: `/${ROUTES.STATISTICAL}/${ROUTES.STATISTICAL_CHILD.BASE_PRICE}`,
        premissions: Perm_PriceBase_View
      })
    ]
  })
]
